import React, { Component, createRef } from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import * as ROUTES from '../../constants/routes';

import { withAuthorization } from '../../session/index';
import { getUserUid } from '../../static/localStorage';

import { Container, Row, Col, Card, CardHeader } from 'reactstrap';
import { Button } from '../../components/elements/buttons/Button';
import { BackIcon } from '../../components/elements/icons/Icons.js';
import { NotificationManager } from 'react-notifications';

import CreateYesNoQuestionPost from '../../components/post/create/YesNoQuestionPost';
import CreateOpenQuestionPost from '../../components/post/create/OpenQuestionPost';
// import CreateRankQuestionPost from '../../components/post/create/RankQuestionPost';
import CreateMultipleQuestionPost from '../../components/post/create/MultipleQuestionPost';

import { convertDateToFirestoreTimestamp } from '../../firebase/api/firestoreUtils';
import { createPost } from '../../firebase/api/post';

import './CreatePost.css';
import Information from '../../components/post/information/Information';
import Checkbox from '../../components/checkbox';
import { ReactComponent as InviteTeamsLogo } from './invite-teams-logo.svg';
import { ReactComponent as InviteIndividualLogo } from './invite-individual-logo.svg';
import { ReactComponent as CategoryLogo } from './category-logo.svg';
import { getUserTeams } from '../../firebase/api/teams';
import { INVITE_ALL_USERS } from '../../constants/post';
import { IS_SIDEKICK_APP } from '../../constants/projects';

const INITIAL_STATE = {
    activeTabYesNoQuestion: true,
    activeTabMultipleQuestion: false,
    // activeTabRankQuestion: false,
    activeTabOpenQuestion: false,
    isPublished: false,
    isInviteAll: false,
    userTeams: [],
    selectedTeam: [],
    selectedIndividual: [],
    selectedCategory: null,
};
const categories = IS_SIDEKICK_APP
    ? [
          {
              label: 'Design',
              value: 'design',
          },
          {
              label: 'Film',
              value: 'film',
          },
          {
              label: 'Animation',
              value: 'animation',
          },
          {
              label: 'Web',
              value: 'web',
          },
          {
              label: 'Strategy',
              value: 'strategy',
          },
      ]
    : [
          {
              label: 'Personal projects',
              value: 'u5h5ctdh84',
          },
          {
              label: 'General questions',
              value: 'gaxwv5y6g9',
          },
          {
              label: 'Work team',
              value: 'r1cq9ri9p9',
          },
      ];

class CreatePost extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };

        this.openQuestionPostRef = createRef();
        this.multipleQuestionPostRef = createRef();
        this.yesNoQuestionPostRef = createRef();
    }

    componentDidMount = () => {
        const userId = getUserUid();
        getUserTeams(userId).then(teams => {
            this.setState({
                userTeams: teams.map(t => ({ label: t.teamName, value: t.teamId })),
            });
        });
    };

    setActiveTab = ({
        activeTabYesNoQuestion,
        activeTabMultipleQuestion,
        activeTabRankQuestion,
        activeTabOpenQuestion,
    }) => {
        this.setState({
            activeTabYesNoQuestion: activeTabYesNoQuestion || false,
            activeTabMultipleQuestion: activeTabMultipleQuestion || false,
            // activeTabRankQuestion: activeTabRankQuestion || false,
            activeTabOpenQuestion: activeTabOpenQuestion || false,
        });
    };

    createPost = dto => {
        this.modifyCreatePostDTO(dto);
        createPost(dto)
            .then(id => {
                this.setState({ isPublished: true });
                this.props.history.push(ROUTES.MY_ALL_POSTS);
            })
            .catch(error => {
                NotificationManager.error('Post not created', error);
            });
    };

    modifyCreatePostDTO = dto => {
        dto.publisherUid = getUserUid();
        dto.createdTimestamp = convertDateToFirestoreTimestamp(new Date());
        dto.isDeleted = false;
        dto.deleteReason = '';
        dto.isApprovedByAdmin = false;
        dto.totalDonations = 0;
    };

    handleBackButtonClick = () => {
        this.props.history.push(ROUTES.POSTS);
    };

    TeamValueContainer = ({ children, ...props }) => {
        return (
            components.ValueContainer && (
                <components.ValueContainer {...props}>
                    {!!children && <InviteTeamsLogo />}
                    {children}
                </components.ValueContainer>
            )
        );
    };

    IndividualValueContainer = ({ children, ...props }) => {
        return (
            components.ValueContainer && (
                <components.ValueContainer {...props}>
                    {!!children && <InviteIndividualLogo />}
                    {children}
                </components.ValueContainer>
            )
        );
    };

    CategoryValueContainer = ({ children, ...props }) => {
        return (
            components.ValueContainer && (
                <components.ValueContainer {...props}>
                    {!!children && <CategoryLogo />}
                    {children}
                </components.ValueContainer>
            )
        );
    };

    handleInviteAllCheckboxChecked = () => {
        this.setState({
            isInviteAll: !this.state.isInviteAll,
        });
    };

    handleInviteTeamChange = e => {
        this.setState({
            selectedTeam: [e.value],
        });
    };

    handleIndividualChange = e => {
        this.setState({
            selectedIndividual: e.map(s => s.value),
        });
    };

    handleCategoryChanged = e => {
        this.setState({
            selectedCategory: e.value,
        });
    };

    handlePublishButtonClick = () => {
        const dto = this.state.activeTabYesNoQuestion
            ? {
                  ...this.yesNoQuestionPostRef.current.state.createPostDTO,
              }
            : this.state.activeTabMultipleQuestion
            ? {
                  ...this.multipleQuestionPostRef.current.state.createPostDTO,
              }
            : this.state.activeTabOpenQuestion
            ? {
                  ...this.openQuestionPostRef.current.state.createPostDTO,
              }
            : {};
        const inviteColleagues = this.state.isInviteAll
            ? [INVITE_ALL_USERS]
            : [...this.state.selectedTeam, ...this.state.selectedIndividual];

        this.createPost({
            ...dto,
            inviteColleagues,
            category: this.state.selectedCategory,
        });
    };

    // isPublishButtonDisabled = () => {
    //     if (!this) {
    //         return true;
    //     }
    //
    //     if (
    //         this.state.activeTabYesNoQuestion &&
    //         !this.yesNoQuestionPostRef.current.state.createPostDTO.title.length
    //     ) {
    //         return true;
    //     }
    //
    //     if (
    //         this.state.activeTabMultipleQuestion &&
    //         !this.multipleQuestionPostRef.current.state.createPostDTO.title.length
    //     ) {
    //         return true;
    //     }
    //
    //     if (
    //         this.state.activeTabOpenQuestion &&
    //         !this.openQuestionPostRef.current.state.createPostDTO.title.length
    //     ) {
    //         return true;
    //     }
    //
    //     return !this.state.selectedCategory;
    // };

    render() {
        const {
            activeTabYesNoQuestion,
            activeTabMultipleQuestion,
            activeTabRankQuestion,
            activeTabOpenQuestion,
            isPublished,
        } = this.state;
        return (
            <Container fluid className="CreatePost">
                <div className="pb-5 card-content">
                    <Card className="create-post">
                        <CardHeader className="d-flex p-4 align-items-center">
                            <div
                                className="align-items-center d-flex"
                                onClick={this.handleBackButtonClick}
                            >
                                <div className="mb-1">
                                    <BackIcon />
                                </div>

                                <span className="ml-2 create-post__header">Back to dashboard</span>
                            </div>
                        </CardHeader>
                        <div className="d-flex question-type__container question-card align-items-center py-4">
                            <div>
                                <input
                                    value="YES / NO"
                                    type="button"
                                    className={classNames('card__type-select', {
                                        'card__type-select--active':
                                            activeTabYesNoQuestion === true,
                                    })}
                                    onClick={() =>
                                        this.setActiveTab({ activeTabYesNoQuestion: true })
                                    }
                                />
                            </div>
                            <div className="card__type-delimetr" />
                            <div>
                                <input
                                    value="Multiple Choice"
                                    type="button"
                                    className={classNames('card__type-select', {
                                        'card__type-select--active':
                                            activeTabMultipleQuestion === true,
                                    })}
                                    onClick={() =>
                                        this.setActiveTab({ activeTabMultipleQuestion: true })
                                    }
                                />
                            </div>
                            <div className="card__type-delimetr" />
                            <div>
                                <input
                                    value="Open Answer"
                                    type="button"
                                    className={classNames('card__type-select', {
                                        'card__type-select--active': activeTabOpenQuestion === true,
                                    })}
                                    onClick={() =>
                                        this.setActiveTab({ activeTabOpenQuestion: true })
                                    }
                                />
                            </div>
                        </div>
                        {activeTabYesNoQuestion && (
                            <CreateYesNoQuestionPost
                                onPublish={this.createPost}
                                isPublished={isPublished}
                                ref={this.yesNoQuestionPostRef}
                            />
                        )}
                        {activeTabMultipleQuestion && (
                            <CreateMultipleQuestionPost
                                onPublish={this.createPost}
                                isPublished={isPublished}
                                ref={this.multipleQuestionPostRef}
                            />
                        )}
                        {activeTabOpenQuestion && (
                            <CreateOpenQuestionPost
                                onPublish={this.createPost}
                                isPublished={isPublished}
                                ref={this.openQuestionPostRef}
                            />
                        )}
                        <div className="create-post__invite-container d-flex flex-column justify-content-around py-4 question-card">
                            <div className="create-post__invite-text">
                                Invite teams and friends to answer your question
                            </div>
                            <div className="d-flex">
                                <Checkbox
                                    initialValue={false}
                                    text={
                                        IS_SIDEKICK_APP
                                            ? 'Invite all Sidekick talent'
                                            : 'Invite all Validate users'
                                    }
                                    onClick={this.handleInviteAllCheckboxChecked}
                                />
                                <div className="ml-3">
                                    <Select
                                        className="create-post__invite-team-container"
                                        classNamePrefix="react-select"
                                        components={{ ValueContainer: this.TeamValueContainer }}
                                        placeholder="Invite team"
                                        isDisabled={this.state.isInviteAll}
                                        options={this.state.userTeams}
                                        onChange={this.handleInviteTeamChange}
                                    />
                                </div>
                                <div className="ml-3">
                                    <CreatableSelect
                                        className="create-post__invite-individual-container"
                                        classNamePrefix="react-select"
                                        components={{
                                            ValueContainer: this.IndividualValueContainer,
                                        }}
                                        placeholder="Invite individuals"
                                        isDisabled={this.state.isInviteAll}
                                        isMulti={true}
                                        isClearable={false}
                                        onChange={this.handleIndividualChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="create-post__category-container question-card py-5">
                            <div className="d-flex align-items-center mb-3">
                                <div>
                                    <Select
                                        className="create-post__invite-team-container"
                                        classNamePrefix="react-select"
                                        components={{ ValueContainer: this.CategoryValueContainer }}
                                        placeholder="Select Post Category"
                                        options={categories}
                                        onChange={this.handleCategoryChanged}
                                    />
                                </div>
                                <div className="ml-5">
                                    <input
                                        type="button"
                                        value="Publish"
                                        className="create-post__publish"
                                        onClick={this.handlePublishButtonClick}
                                    />
                                </div>
                            </div>
                            <div className="create-post__publish-description">
                                <b>Post Categories</b> are there to help organise the content of
                                your posts
                            </div>
                        </div>
                    </Card>
                </div>
            </Container>
        );
    }
}

const condition = authUser => !!authUser;

export default compose(withAuthorization(condition), withRouter)(CreatePost);
